import { useMemo } from 'react';

import { useQuery } from '@mint-lib/query-client';
import { useAtom } from 'jotai';

import { getQueryScheduleOption } from '../queries/schedule.js';
import {
  editScheduleItemAtom,
  isOpenScheduleDialogAtom,
} from '../store/scheduleDrawer.js';

export const useToggleScheduleDialog = () => {
  const { data: queryScheduleData = [] } = useQuery({
    ...getQueryScheduleOption(),
  });

  const [isOpenScheduleDialog, setIsOpenScheduleDialog] = useAtom(
    isOpenScheduleDialogAtom,
  );
  const [editQueryId, setEditQueryId] = useAtom(editScheduleItemAtom);

  const editQuery = useMemo(() => {
    return (
      queryScheduleData.find((s) => s.scheduledQueryId === editQueryId) || null
    );
  }, [queryScheduleData, editQueryId]);

  return {
    isOpenScheduleDialog,
    setIsOpenScheduleDialog,
    setEditQuery: setEditQueryId,
    editQuery,
  };
};
